module.exports = __webpack_public_path__ + "static/event2-673ab5a07acecdf35afea7a2b9a45c20.jpg";